import { EwaybillAccountListWithExpiredInfo } from "@/services/api/ewaybillAccount";
import { Empty, Table } from "antd";
import React from "react";
import { getEwaybillAccountMapping } from "@/services/api/ewaybillAccount";
import useColumns from "./useColumns";
import ExpiredAlert from "../ExpiredAlert";

interface EwaybillAccountTableProps {
  info?: EwaybillAccountListWithExpiredInfo;

  loading?: boolean;
}

const EwaybillAccountTable: React.FC<EwaybillAccountTableProps> = function (props) {
  const { info, loading } = props;

  const result = getEwaybillAccountMapping(info?.items || []);

  const columns = useColumns({
    ...result,
  });

  return (
    <>
      <ExpiredAlert
        totalHasExpiredCount={info?.totalHasExpiredCount}
        totalWillExpiredCount={info?.totalWillExpiredCount}
      />

      <Table
        rowKey="id"
        bordered
        loading={loading}
        columns={columns}
        dataSource={result.allShippingAddresses}
        pagination={false}
        size="small"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="请先授权至少一个电子面单账号，完成后就可以共享电子面单给其他店铺"
            />
          ),
        }}
      ></Table>
    </>
  );
};

export default React.memo(EwaybillAccountTable);
